import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelText as _vModelText, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34c1f3b5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "accordion-item" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "accordion-header",
  id: "panelsStayOpen-headingTwo"
}, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "accordion-button collapsed",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#panelsStayOpen-collapseTwo",
    "aria-expanded": "false",
    "aria-controls": "panelsStayOpen-collapseTwo"
  }, " DESIGN RULE CHECK ")
], -1))
const _hoisted_3 = {
  id: "panelsStayOpen-collapseTwo",
  class: "accordion-collapse collapse",
  "aria-labelledby": "panelsStayOpen-headingTwo"
}
const _hoisted_4 = {
  class: "accordion-body panel-item-height",
  style: {"max-height":"500px"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-magnifying-glass" }, null, -1))
const _hoisted_6 = { class: "list-group list-group-flush" }
const _hoisted_7 = { class: "form-check form-switch" }
const _hoisted_8 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_9 = ["onUpdate:modelValue"]
const _hoisted_10 = { class: "form-check-label me-2" }
const _hoisted_11 = {
  key: 0,
  class: "input-group flex-nowrap my-2 w-auto"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "input-group-text p-1" }, "µm", -1))
const _hoisted_13 = {
  key: 1,
  class: "input-group flex-nowrap my-2 w-auto"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "input-group-text p-1" }, "µm", -1))
const _hoisted_15 = {
  key: 2,
  class: "input-group flex-nowrap my-2 w-auto"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "input-group-text p-1" }, "µm", -1))
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 0,
  class: "fa-solid fa-check text-success"
}
const _hoisted_19 = ["data-bs-target", "aria-controls"]
const _hoisted_20 = ["id"]
const _hoisted_21 = { class: "card card-body py-0 border-warning" }
const _hoisted_22 = { class: "list-group list-group-flush list-group-numbered" }
const _hoisted_23 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PartListButtonVue = _resolveComponent("PartListButtonVue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "btn btn-primary btn-sm mb-3 me-3",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.runDRC()))
        }, [
          _hoisted_5,
          _createTextVNode(" Run DRC ")
        ]),
        _createElementVNode("ul", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.designRules, (designRule, idx) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "list-group-item px-0",
              key: idx
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      role: "switch",
                      "onUpdate:modelValue": ($event: any) => ((designRule.isChecked) = $event)
                    }, null, 8, _hoisted_9), [
                      [_vModelCheckbox, designRule.isChecked]
                    ]),
                    _createElementVNode("label", _hoisted_10, _toDisplayString(designRule.description), 1)
                  ]),
                  (idx === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-control p-1",
                          style: {"width":"100px"},
                          type: "number",
                          min: "10",
                          step: "10",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.channelWidthMin) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.channelWidthMin]
                        ]),
                        _hoisted_12
                      ]))
                    : (idx === 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-control p-1",
                            style: {"width":"100px"},
                            type: "number",
                            min: "10",
                            step: "10",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.compDistMin) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.compDistMin]
                          ]),
                          _hoisted_14
                        ]))
                      : (idx === 2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-control p-1",
                              style: {"width":"100px"},
                              type: "number",
                              min: "10",
                              step: "10",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.minPortRadius) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.minPortRadius]
                            ]),
                            _hoisted_16
                          ]))
                        : _createCommentVNode("", true)
                ]),
                (designRule.isChecked)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      (designRule.result === 0)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_18))
                        : (designRule.result > 0)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "btn btn-warning",
                              style: {"--bs-btn-padding-y":"0","--bs-btn-padding-x":"0.25rem","--bs-btn-font-size":"0.75rem"},
                              type: "button",
                              "data-bs-toggle": "collapse",
                              "data-bs-target": `#collapse${idx}`,
                              "aria-expanded": "false",
                              "aria-controls": `#collapse${idx}`
                            }, _toDisplayString(designRule.result) + " " + _toDisplayString(designRule.result === 1 ? "warning" : "warnings"), 9, _hoisted_19))
                          : _createCommentVNode("", true),
                      (designRule.result > 0)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            class: "collapse mt-2",
                            id: `collapse${idx}`
                          }, [
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("ol", _hoisted_22, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(designRule.failedItems, (failedElm, idx) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    class: "list-group-item px-0 d-flex",
                                    key: idx
                                  }, [
                                    (typeof failedElm === 'string')
                                      ? (_openBlock(), _createBlock(_component_PartListButtonVue, {
                                          key: 0,
                                          id: failedElm
                                        }, null, 8, ["id"]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(failedElm, (id, idx) => {
                                            return (_openBlock(), _createBlock(_component_PartListButtonVue, {
                                              key: idx,
                                              id: id
                                            }, null, 8, ["id"]))
                                          }), 128))
                                        ]))
                                  ]))
                                }), 128))
                              ])
                            ])
                          ], 8, _hoisted_20))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}